module.exports = __webpack_public_path__ + "img/Merchants.b47a73bc.jpg";